import { useTranslation } from 'react-i18next';
import useTimeAgo from '../../../../../../../../../../../Hooks/useTimeAgo';
import { DetectionFieldsFragment } from '../../../../../../../../../../../generated/core-api/graphql-react-query';
import StyledTypography from './styles';

function DetectionLine(props: { detection: DetectionFieldsFragment, isHighlighted: boolean }) {
  const { detection, isHighlighted } = props;
  const timeAgo = useTimeAgo(detection.date);
  const { t } = useTranslation();

  return (
    <StyledTypography key={detection.id} isHighlighted={isHighlighted}>
      <strong>{detection.command?.name}</strong>
      {t('detections.detected', { timeAgo })}
    </StyledTypography>
  );
}

export default DetectionLine;
